import React, { useState } from 'react';
import apiService from '../services/apiService';
import { diasEntreDatas } from '../utils/dateFromDays';

const SpecifyDayPanel = ({ distribuicao, params, showPDF, onPontoMarcado, dataReferencia }) => {
    const [mostrarPainel, setMostrarPainel] = useState(false);
    const [inputValor, setInputValor] = useState('');
    const [inputData, setInputData] = useState('');
    const [calculando, setCalculando] = useState(false);
    const [erroCalculo, setErroCalculo] = useState(null);

    const modoData = !!dataReferencia;

    const fecharPainel = () => {
        setMostrarPainel(false);
        setInputValor('');
        setInputData('');
        setErroCalculo(null);
        onPontoMarcado(null);
    };

    const calcularPonto = async () => {
        let valor;
        if (modoData) {
            const dias = diasEntreDatas(inputData, dataReferencia);
            if (dias === null || isNaN(dias)) {
                setErroCalculo('Selecione uma data válida.');
                return;
            }
            valor = dias;
        } else {
            valor = parseFloat(inputValor);
            if (isNaN(valor)) {
                setErroCalculo('Insira um valor numérico válido.');
                return;
            }
        }
        setErroCalculo(null);
        setCalculando(true);
        try {
            const resultado = await apiService.calcularPontoDistribuicao(distribuicao, params, valor);
            onPontoMarcado({ valor, pdf: resultado.pdf, cdf: resultado.cdf });
        } catch (e) {
            setErroCalculo('Erro ao calcular. Tente novamente.');
        } finally {
            setCalculando(false);
        }
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
            {mostrarPainel && (
                <>
                    {modoData ? (
                        <input
                            type="date"
                            value={inputData}
                            onChange={e => { setInputData(e.target.value); setErroCalculo(null); }}
                            onKeyDown={e => e.key === 'Enter' && calcularPonto()}
                            style={{
                                border: '1px solid #d1d5db',
                                borderRadius: '6px',
                                padding: '6px 10px',
                                fontSize: '13px',
                                width: '160px'
                            }}
                        />
                    ) : (
                        <input
                            type="number"
                            value={inputValor}
                            onChange={e => { setInputValor(e.target.value); setErroCalculo(null); }}
                            onKeyDown={e => e.key === 'Enter' && calcularPonto()}
                            placeholder="Valor (dias)"
                            style={{
                                border: '1px solid #d1d5db',
                                borderRadius: '6px',
                                padding: '6px 10px',
                                fontSize: '13px',
                                width: '130px'
                            }}
                        />
                    )}
                    <button
                        onClick={calcularPonto}
                        disabled={calculando}
                        style={{ backgroundColor: '#003B6B' }}
                        className="text-white font-semibold py-1 px-4 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
                    >
                        {calculando ? 'Calculando...' : 'Calcular'}
                    </button>
                </>
            )}
            <button
                onClick={() => mostrarPainel ? fecharPainel() : setMostrarPainel(true)}
                style={{ backgroundColor: mostrarPainel ? undefined : '#003B6B' }}
                className={mostrarPainel
                    ? 'text-gray-600 font-medium py-1 px-4 rounded-lg border border-gray-300 hover:bg-gray-50 transition-all duration-200 text-sm'
                    : 'text-white font-semibold py-1 px-4 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg hover:opacity-90 text-sm'
                }
            >
                {mostrarPainel ? 'Fechar' : (modoData ? 'Especificar data' : 'Especificar valor')}
            </button>
            {erroCalculo && <span style={{ fontSize: '13px', color: '#dc2626' }}>{erroCalculo}</span>}

        </div>
    );
};

export default SpecifyDayPanel;
